import { useEffect } from 'react';
import type { Maybe } from 'types/Utilities';
import { assignLocation } from './assignLocation';

function useAssignLocation({
  url,
  enabled,
}: {
  url: Maybe<string>;
  enabled: boolean;
}) {
  useEffect(() => {
    if (enabled && url) {
      assignLocation(url);
    }
  }, [url, enabled]);
}

function AssignLocation({ url }: { url: string }) {
  useAssignLocation({ url, enabled: true });
  return null;
}

export { AssignLocation, useAssignLocation };
